/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState,useEffect, useContext } from 'react';
import { motion } from "framer-motion";
import { useLocation, useNavigate } from 'react-router-dom';
import Filter from './Filter';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import StatusBar from '../StatusBar';
import { pushOrRemoveElement } from '../../CommonMethods/pushOrRemoveElement';
import { useSelector } from 'react-redux';
import Loader from '../Loader';
import GlobalContext from '../../components/Context/GloablContext';

const TopBar = ({
    customPaddingBottomForMainDiv,
    customSearchPlaceHolder,
    customSearchBarWidth,
    dateRangeFilterName,
    filterFromPage,
    branchUser,
    ApplyFilter,
    optimizedFn,
    FilterData,
    AddButton, 
    Tittle, 
    SearchInput, 
    AddButtonName, 
    handleOnClickSearch, 
    SearchValue, 
    isClick,
    FilterCheckbox,
    setFilterCheckBox,
    handleApplyFilter,
    filterCount,
    handleFilters,
    status,
    statusBarList,
    searchParams,
    BranchDisabled,
    selectedFilterTerm,
    tooltip,
    handleSidePopupClick,
    isSampleFileDownload,
    handleSampleFileDownload,
    dotedLoader,
    handleImportFile,
    showAddButtonalways,
    isUpload}) => {
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    
    const location=useNavigate();
    const locate=useLocation()

    const {  isInactiveBranch } = useContext(GlobalContext);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const {userType}=useSelector(state=>state.auth)
    const [searchValue1, setSearchValue] = useState(SearchValue);
    const [isClearVisible, setClearVisible] = useState(false);

    showAddButtonalways == (showAddButtonalways == undefined)?false:showAddButtonalways;

    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    useEffect(() => {
        if (SearchValue !== undefined) {
            setSearchValue(SearchValue);
            setClearVisible(SearchValue.length > 0);
        }
    }, [SearchValue]);

    useEffect(() => {
        if(selectedFilterTerm !== undefined ) {
            setSelectedFilter(selectedFilterTerm)
        }
        setClearVisible(searchValue1.length > 0);
    }, [locate])

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            performSearch(searchValue1);
        }
    };

    const clearAndperformSearch = (e) => {
        setSearchValue('');
        performSearch('');
    }

    const performSearch = (searchVal) => {
        searchVal = searchVal == undefined ? searchValue1 : searchVal;
        if (optimizedFn === undefined) {
            handleOnClickSearch('search', searchVal);
        } else {
            handleOnClickSearch(searchVal);
            optimizedFn !== undefined && optimizedFn('search', searchVal);
        }
    };

    
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen(!isFilterOpen)
    }
    
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            if(FilterCheckbox[selectedFilter] === undefined) {
                FilterCheckbox[selectedFilter] = [];
                setFilterCheckBox(FilterCheckbox);
            }
            const array = pushOrRemoveElement(FilterCheckbox[selectedFilter], selectedFilter === "status" ?id.toLowerCase() : id);
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:array
            }))
        }
    }
    return (
        <>
            <div className={`${isUpload?`flex justify-between items-center px-10 pt-[21px]`:`flex justify-between items-center ${customPaddingBottomForMainDiv === undefined ? '' : `pb-[${customPaddingBottomForMainDiv}]`} bg-[#fff] mr-1`}`}>
                {!branchUser ?
                    Tittle!== undefined && <h5 className="pageHeader">
                        {Tittle}</h5>
                    :
                    Tittle!== undefined && <p class="text-lg font-semibold text-[#000000]">{Tittle}</p>
                }
                <div className="flex items-center">
                    {status!==undefined  && <StatusBar handleFilters={handleFilters} status={status} statusBarList={statusBarList}/>}
                    {SearchInput &&<div className="relative search-tab">
                        <label htmlFor="input"></label>
                        <div className="top-[52%] -translate-y-[50%]" id='search_button' >
                            <motion.button
                                type="button"
                                // disabled={loading===true}
                                id="search-button"
                                className="inline-block"
                                data-te-toggle="modal"
                                data-te-target="#exampleModalCenter"
                                data-te-ripple-init
                                data-te-ripple-color="light">
                                <img loading="lazy" decoding="async" src="/images/search.svg" alt="img"
                                />
                            </motion.button>
                        </div>
                        <div class="relative flex">
                            <input
                                maxLength={90}
                                type="text"
                                autoComplete='off'
                                id="search-value"
                                value={searchValue1}
                                // disabled={loading === true}
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                className={`${customSearchBarWidth === undefined ? 'w-[220px]' : `w-[${customSearchBarWidth}]`} `}
                                placeholder={customSearchPlaceHolder}
                            />
                        </div>
                        {isClearVisible && <div className='absolute cross_icon' id='clear_icon' onClick={clearAndperformSearch} title='Clear Seach'></div>}
                        
                        {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                            <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
                        </button> --> */}
                    </div>}                    
                    {(ApplyFilter !== undefined && ApplyFilter) && <div class="relative">
                        <button onClick={() => handleOpenFilter()} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen &&  
                        <Filter 
                            ref={outSideClick}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            filterCount={filterCount}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                            tooltip={tooltip}
                            dateRangeFilterName={dateRangeFilterName}
                            filterFromPage={filterFromPage}
                        />}
                    </div>}
                    {AddButton && (!isInactiveBranch || showAddButtonalways) &&
                    <>{isClick===undefined?
                        <motion.button
                        // whileHover={{ scale: 1.05 }}
                            onClick={() =>handleSidePopupClick('Add')}
                            disabled={BranchDisabled === undefined ? false : !BranchDisabled}
                            type="button"
                            className="prmy-btn" id="addAdmin_user" data-te-offcanvas-toggle
                            data-te-target="#offcanvasAddminUser" aria-controls="offcanvasAddminUser">
                            {AddButtonName}
                        </motion.button>:
                        <>
                            <motion.button
                                // whileHover={{ scale: 1.05 }}
                                onClick={() =>location(isClick)}
                                type="button"
                                className="prmy-btn" id="addAdmin_user" data-te-offcanvas-toggle
                                data-te-target="#offcanvasAddminUser" aria-controls="offcanvasAddminUser">
                                {AddButtonName}
                            </motion.button>
                            {isUpload&&
                            (dotedLoader === "import" ?
                                <button 
                                    type="button" 
                                    className="prmy-btn" 
                                    id="addAdmin_user" 
                                    onClick={() => handleSampleFileDownload()}
                                > <Loader />
                                </button>
                                :
                                <div className={`relative prmy-btn`}>
                                    <label className="cursor-pointer">
                                        <span>Upload</span>
                                        <input
                                            id="Upload"
                                            onChange={(e) => handleImportFile(e)}
                                            accept=".xlsx, .xls"
                                            data-allowed-file-extensions=".xlsx,.xls"
                                            type="file"
                                            className={`opacity-0 absolute top-0 left-0 w-full h-full importBtn`}
                                            title=""
                                        />
                                    </label>
                                </div> 
                            )}
                            {isSampleFileDownload&&
                            <button 
                                type="button" 
                                
                                className="prmy-btn" 
                                id="sample" 
                                onClick={() => handleSampleFileDownload()}
                            > {dotedLoader === "sample" ? <Loader /> : "Sample File"}
                            </button>}
                        </>
                    }
                    </>}
                </div>
            
            </div>
           
            
        </>
            
        
    );
}

export default TopBar;
